import type { LexicalNode } from 'lexical'
import { createCommand } from 'lexical'
import type { StrategyBasedInsertContentItemSource } from '../../types'
import type { ActionPayload } from './nodes/ActionContainerNode/ActionContainerNodeHeadless'
import type { AgendaPayload } from './nodes/AgendaContainerNode/AgendaContainerNodeHeadless'
import type { AttachmentItemPayload } from './nodes/AttachmentContentNode/AttachmentContentNodeHeadless'
import type { DecisionPayload } from './nodes/DecisionContainerNode/DecisionContainerNodeHeadless'
import type { PollItemPayload } from './nodes/PollContentNode/PollContentNodeHeadless'
import type { NewSectionTitlePayload } from './nodes/section-title/SectionTitleContainerNode/SectionTitleContainerNodeHeadless'

const INSERT_CONTENT_ITEM_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    createContentItem: (contentItemId?: string) => LexicalNode
}>('INSERT_CONTENT_ITEM_COMMAND')

const INSERT_ACTION_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<ActionPayload>
}>('INSERT_ACTION_COMMAND')

const INSERT_AGENDA_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<AgendaPayload>
}>('INSERT_AGENDA_COMMAND')

const INSERT_DECISION_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<DecisionPayload>
}>('INSERT_DECISION_COMMAND')

const INSERT_POLL_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload: PollItemPayload
}>('INSERT_POLL_COMMAND')

const INSERT_ATTACHMENT_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload: AttachmentItemPayload
}>('INSERT_ATTACHMENT_COMMAND')

const INSERT_SECTION_TITLE_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<NewSectionTitlePayload>
}>('INSERT_SECTION_TITLE_COMMAND')

const OPEN_CREATE_POLL_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
    payload?: Partial<PollItemPayload>
}>('OPEN_CREATE_POLL_COMMAND')

const OPEN_UPLOAD_ATTACHMENT_COMMAND = createCommand<{
    source: StrategyBasedInsertContentItemSource
}>('OPEN_UPLOAD_ATTACHMENT_COMMAND')

const PREVIEW_ATTACHMENT_COMMAND = createCommand<{
    title: string
    path: string
}>('PREVIEW_ATTACHMENT_COMMAND')

const OPEN_DOCUMENT_ANNOTATION_COMMAND = createCommand<{
    id: string
    filename: string
    path: string
}>('OPEN_DOCUMENT_ANNOTATION_COMMAND')

const OPEN_DOCUMENT_PRESENTATION_COMMAND = createCommand<{
    id: string
    filename: string
    attachmentPath: string
}>('OPEN_DOCUMENT_PRESENTATION_COMMAND')

export {
    INSERT_CONTENT_ITEM_COMMAND,
    INSERT_ACTION_COMMAND,
    INSERT_AGENDA_COMMAND,
    INSERT_DECISION_COMMAND,
    INSERT_POLL_COMMAND,
    INSERT_ATTACHMENT_COMMAND,
    INSERT_SECTION_TITLE_COMMAND,
    OPEN_CREATE_POLL_COMMAND,
    OPEN_UPLOAD_ATTACHMENT_COMMAND,
    PREVIEW_ATTACHMENT_COMMAND,
    OPEN_DOCUMENT_ANNOTATION_COMMAND,
    OPEN_DOCUMENT_PRESENTATION_COMMAND,
}
